import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import './Login.css';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const result = await login(email, password);

      if (!result.success) {
        // Handle specific error messages from backend
        if (result.status === 401) {
          setError('Invalid email or password. Please check your credentials.');
        } else if (result.status === 404) {
          setError('User not found. Please check your email address.');
        } else if (result.status === 403) {
          setError('Account is disabled or suspended. Please contact support.');
        } else if (result.status === 429) {
          setError('Too many login attempts. Please try again later.');
        } else if (result.status >= 500) {
          setError('Server error. Please try again later or contact support.');
        } else if (result.message) {
          // Use the specific error message from backend
          setError(result.message);
        } else {
          setError('Login failed. Please try again.');
        }
      }
    } catch (error) {
      // Handle network errors or unexpected errors
      if (error.name === 'NetworkError' || error.code === 'NETWORK_ERROR') {
        setError('Network error. Please check your internet connection.');
      } else if (error.message?.includes('fetch')) {
        setError('Unable to connect to server. Please try again later.');
      } else {
        setError('An unexpected error occurred. Please try again.');
      }
      console.error('Login error:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="loginPage-container">
      <div className="loginPage-left">
        <div className="loginPage-formContainer">
          <div className="loginPage-logoMobile">
            <img src="/login-logo-blue.svg" alt="KaamDhanda Logo" className="loginPage-logo" />
          </div>
          <h1>Welcome!</h1>
          <p className="loginPage-subtitle">Please enter your credentials to continue</p>

          {error && (
            <div className="loginPage-errorBanner">
              <i className="loginPage-errorIcon">!</i>
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="loginPage-inputGroup">
              <label htmlFor="email">Email</label>
              <div className="loginPage-inputWithIcon">
                <i className="loginPage-inputIcon loginPage-userIcon"></i>
                <input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                    if (error) setError('');
                  }}
                  placeholder="Enter your email"
                  required
                />
              </div>
            </div>

            <div className="loginPage-inputGroup">
              <label htmlFor="password">Password</label>
              <div className="loginPage-inputWithIcon">
                <i className="loginPage-inputIcon loginPage-passwordIcon"></i>
                <input
                  className='loginPage-passwordInput'
                  id="password"
                  type={showPassword ? 'text' : 'password'}
                  value={password}
                  onChange={(e) => {
                    setPassword(e.target.value);
                    if (error) setError('');
                  }}
                  placeholder="Enter your password"
                  required
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  aria-label="Toggle password visibility"
                  style={{ position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)', background: 'transparent', border: 'none', cursor: 'pointer', padding: 4 }}
                >
                  {showPassword ? (
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M17.94 17.94A10.94 10.94 0 0 1 12 20c-5 0-9.27-3.11-11-8 1.02-2.77 2.99-5.05 5.47-6.46"/>
                      <path d="M1 1l22 22"/>
                      <path d="M9.88 9.88A3 3 0 0 0 12 15a3 3 0 0 0 2.12-.88"/>
                    </svg>
                  ) : (
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                      <circle cx="12" cy="12" r="3"/>
                    </svg>
                  )}
                </button>
              </div>
            </div>

            <button
              type="submit"
              className="loginPage-button"
              disabled={loading}
            >
              {loading ? (
                <span className="loginPage-loadingSpinner"></span>
              ) : (
                'Login'
              )}
            </button>
          </form>

          <div className="loginPage-footer">
            <p>Don't have an account? <a href="https://wa.me/918699811226?text=Hello%2C%20I%20Want%20to%20know%20more%20about%20KaamDhanda.">Contact us</a></p>
          </div>
        </div>
      </div>

      <div className="loginPage-right">
        <div className="loginPage-brandContainer">
          {/* <img src="/KD-icon-transparent.png" alt="KaamDhanda Logo" className="loginPage-logoLarge loginPage-logo-width-45" /> */}
          <img src="/login-logo.svg" alt="KaamDhanda Logo" className="loginPage-logoLarge loginPage-logo-width-90" />
        </div>
      </div>
    </div>
  );
};

export default Login; 